import Shop from '../shop';

export default class PizzaDelivery extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Pizza delivery',
            id:                   'PizzaDelivery',
            coolDown:             60,
            faClass:              'fae-pizza',
            individualCostFactor: 1.14,
            baseEarnings:         4320.0,
            baseCosts:            8640.0,
            grade:                4
        });
    }
}
